import styled from '@emotion/styled/macro';

export const Container = styled.div`
  .recharts-label-list {
    text {
      fill: #000;
    }
  }
`;
